import { render } from "./Config.vue?vue&type=template&id=d0b02d08"
import script from "./Config.vue?vue&type=script&lang=ts"
export * from "./Config.vue?vue&type=script&lang=ts"
script.render = render

export default script